// src/features/statusdiario/api.js
import api from "../../api/axios";

const SD_DEBUG = true; // ou usa env se preferir

function dlog(...args) {
  if (SD_DEBUG) console.log("[SD][api]", ...args);
}

// GET /api/status_diario?day=YYYY-MM-DD&gerencia=...&ativo=...
export async function getStatusDiario({ day, gerencia, ativo, signal } = {}) {
  const params = {};
  if (day) params.day = day;
  if (gerencia) params.gerencia = gerencia;
  if (ativo) params.ativo = ativo;

  // ✅ mata cache (igual teu wf_3/listar)
  params._ = Date.now();

  const rid = Math.random().toString(36).slice(2, 8);
  dlog(`GET rid=${rid}`, params);

  const res = await api.get("/status_diario", {
    params,
    signal,
    headers: {
      // ✅ força browser/proxy a não reutilizar resposta antiga
      "Cache-Control": "no-store",
      Pragma: "no-cache",
    },
  });

  dlog(`RES rid=${rid} status=${res.status} count=${res.data?.count ?? "?"}`);

  return res.data; // { ok, day, count, rows }
}
